import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Navigation from './components/Navigation';
import PrivateRoute from './components/PrivateRoute';

// Pages
import HomePage from './pages/HomePage';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Setup2FA from './pages/Setup2FA';
import Verify2FA from './pages/Verify2FA';
import Dashboard from './pages/Dashboard';
import ListVehicle from './pages/ListVehicle';
import Auctions from './pages/Auctions';
import AuctionDetail from './pages/AuctionDetail';
import Payouts from './pages/Payouts';
import Analytics from './pages/Analytics';
import Messages from './pages/Messages';

function App() {
  return (
    <Router>
      <AuthProvider>
        <Navigation />
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/setup-2fa" element={<Setup2FA />} />
          <Route path="/verify-2fa" element={<Verify2FA />} />

          {/* Private Routes */}
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/list-vehicle"
            element={
              <PrivateRoute>
                <ListVehicle />
              </PrivateRoute>
            }
          />
          <Route
            path="/auctions"
            element={
              <PrivateRoute>
                <Auctions />
              </PrivateRoute>
            }
          />
          <Route
            path="/auction/:auctionId"
            element={
              <PrivateRoute>
                <AuctionDetail />
              </PrivateRoute>
            }
          />
          <Route
            path="/payouts"
            element={
              <PrivateRoute>
                <Payouts />
              </PrivateRoute>
            }
          />
          <Route
            path="/analytics"
            element={
              <PrivateRoute>
                <Analytics />
              </PrivateRoute>
            }
          />
          <Route
            path="/messages"
            element={
              <PrivateRoute>
                <Messages />
              </PrivateRoute>
            }
          />

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
